// The list is based on https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
// And formatted / prepared by ChatGPT.

export const code_KeyA = 'KeyA';
export const code_KeyB = 'KeyB';
export const code_KeyC = 'KeyC';
export const code_KeyD = 'KeyD';
export const code_KeyE = 'KeyE';
export const code_KeyF = 'KeyF';
export const code_KeyG = 'KeyG';
export const code_KeyH = 'KeyH';
export const code_KeyI = 'KeyI';
export const code_KeyJ = 'KeyJ';
export const code_KeyK = 'KeyK';
export const code_KeyL = 'KeyL';
export const code_KeyM = 'KeyM';
export const code_KeyN = 'KeyN';
export const code_KeyO = 'KeyO';
export const code_KeyP = 'KeyP';
export const code_KeyQ = 'KeyQ';
export const code_KeyR = 'KeyR';
export const code_KeyS = 'KeyS';
export const code_KeyT = 'KeyT';
export const code_KeyU = 'KeyU';
export const code_KeyV = 'KeyV';
export const code_KeyW = 'KeyW';
export const code_KeyX = 'KeyX';
export const code_KeyY = 'KeyY';
export const code_KeyZ = 'KeyZ';
export const code_Digit0 = 'Digit0';
export const code_Digit1 = 'Digit1';
export const code_Digit2 = 'Digit2';
export const code_Digit3 = 'Digit3';
export const code_Digit4 = 'Digit4';
export const code_Digit5 = 'Digit5';
export const code_Digit6 = 'Digit6';
export const code_Digit7 = 'Digit7';
export const code_Digit8 = 'Digit8';
export const code_Digit9 = 'Digit9';
export const code_Escape = 'Escape';
export const code_F1 = 'F1';
export const code_F2 = 'F2';
export const code_F3 = 'F3';
export const code_F4 = 'F4';
export const code_F5 = 'F5';
export const code_F6 = 'F6';
export const code_F7 = 'F7';
export const code_F8 = 'F8';
export const code_F9 = 'F9';
export const code_F10 = 'F10';
export const code_F11 = 'F11';
export const code_F12 = 'F12';
export const code_PrintScreen = 'PrintScreen';
export const code_ScrollLock = 'ScrollLock';
export const code_Pause = 'Pause';
export const code_Insert = 'Insert';
export const code_Home = 'Home';
export const code_PageUp = 'PageUp';
export const code_Delete = 'Delete';
export const code_End = 'End';
export const code_PageDown = 'PageDown';
export const code_ArrowUp = 'ArrowUp';
export const code_ArrowLeft = 'ArrowLeft';
export const code_ArrowDown = 'ArrowDown';
export const code_ArrowRight = 'ArrowRight';
export const code_ContextMenu = 'ContextMenu';
export const code_CapsLock = 'CapsLock';
export const code_Tab = 'Tab';
export const code_Backspace = 'Backspace';
export const code_Enter = 'Enter';
export const code_ShiftLeft = 'ShiftLeft';
export const code_ControlLeft = 'ControlLeft';
export const code_AltLeft = 'AltLeft';
export const code_MetaLeft = 'MetaLeft';
export const code_ShiftRight = 'ShiftRight';
export const code_ControlRight = 'ControlRight';
export const code_AltRight = 'AltRight';
export const code_MetaRight = 'MetaRight';
export const code_Space = 'Space';
export const code_NumLock = 'NumLock';
export const code_Numpad0 = 'Numpad0';
export const code_Numpad1 = 'Numpad1';
export const code_Numpad2 = 'Numpad2';
export const code_Numpad3 = 'Numpad3';
export const code_Numpad4 = 'Numpad4';
export const code_Numpad5 = 'Numpad5';
export const code_Numpad6 = 'Numpad6';
export const code_Numpad7 = 'Numpad7';
export const code_Numpad8 = 'Numpad8';
export const code_Numpad9 = 'Numpad9';
export const code_NumpadAdd = 'NumpadAdd';
export const code_NumpadSubtract = 'NumpadSubtract';
export const code_NumpadMultiply = 'NumpadMultiply';
export const code_NumpadDivide = 'NumpadDivide';
export const code_NumpadDecimal = 'NumpadDecimal';
export const code_IntlBackslash = 'IntlBackslash';
export const code_IntlRo = 'IntlRo';
export const code_IntlYen = 'IntlYen';
export const code_NumpadComma = 'NumpadComma';
export const code_Convert = 'Convert';
export const code_NonConvert = 'NonConvert';
export const code_Lang1 = 'Lang1';
export const code_Lang2 = 'Lang2';
export const code_Lang3 = 'Lang3';
export const code_Lang4 = 'Lang4';
export const code_Lang5 = 'Lang5';